<template>
    <div class="index-serviceProcess">
        <div class="index-serviceProcess-des">
            <div class="index-serviceProcess-des-process" :class="{active:isActive}" ref="serviceProcess">{{
                $t('serviceProcess.process')}}
            </div>
        </div>
        <div class="index-serviceProcess-chart">
            <div class="index-serviceProcess-chart-Wrapper" ref="chartOdd">
                    <span v-if="$i18n.locale==='zh'" class="index-serviceProcess-chart-odd"
                          :class="{[`active-1`]:oddShow||isActive}">
                         <img class="img" src="../../assets/中文.png" alt="">
                    </span>
                <span v-if="$i18n.locale==='en'" class="index-serviceProcess-chart-odd"
                      :class="{[`active-1`]:oddShow||isActive}">
                         <img class="img" src="../../assets/英文.png" alt="">
                    </span>
            </div>
        </div>
        <div class="banner-line" ref="bannerLine"></div>
    </div>
</template>

<script>
    import {isPC} from '../../utils/methods'

    export default {
        name: "serviceProgress",
        props: {
            serveChartShow: Boolean,
            oddShow: Boolean,
        },
        computed:{
          chartImg(){
              if(this.$i18n.locale==='zh'){
                  return this.serviceChartZh
              }else{
                  return this.serviceChartEn
              }
          }
        },
        data() {
            return {
                serviceChartEn: [
                    {img:require('../../assets/chart/1.png')},
                    {img:require('../../assets/chart/2.png')},
                    {img:require('../../assets/chart/3.png')},
                    {img:require('../../assets/chart/6.png')},
                    {img:require('../../assets/chart/5.png')},
                    {img:require('../../assets/chart/4.png')},
                    {img:require('../../assets/chart/7.png')},
                    {img:require('../../assets/chart/8.png')},
                    {img:require('../../assets/chart/9.png')},
                ],
                serviceChartZh: [
                    {img:require('../../assets/chart/服务流程1.png')},
                    {img:require('../../assets/chart/服务流程2.png')},
                    {img:require('../../assets/chart/服务流程3.png')},
                    {img:require('../../assets/chart/服务流程6.png')},
                    {img:require('../../assets/chart/服务流程5.png')},
                    {img:require('../../assets/chart/服务流程4.png')},
                    {img:require('../../assets/chart/服务流程7.png')},
                    {img:require('../../assets/chart/服务流程8.png')},
                    {img:require('../../assets/chart/服务流程9.png')},
                ],
                isActive: false,
            }

        },
        mounted() {
            if (this.$route.fullPath === '/product') {
                this.addScrollListener()
            }
        },
        beforeDestroy() {
            this.removeListener()
        },
        methods: {
            addScrollListener() {
                let $root;
                $root = isPC() ? document.documentElement : document.body
                this.eventType = isPC() ? 'scroll' : 'touchmove'
                this.scrollEventListener = () => {
                    let {scrollTop} = $root
                    if (scrollTop > 200) {
                        this.isActive = true
                    }
                    if (scrollTop > 230) {
                        this.isActive = true
                        this.removeListener()
                    }
                }
                window.addEventListener(this.eventType, this.scrollEventListener)
            },
            removeListener() {
                window.removeEventListener(this.eventType, this.scrollEventListener)
            },
            beforeEnter(el) {
                el.style.height = 0
                el.style.paddingTop = 0
                el.style.paddingBottom = 0
            },
            enter(el) {
                if (el.children[0].scrollHeight > 0) {
                    el.style.height = el.children[0].scrollHeight + 'px'
                    el.style.overflow = 'hidden'
                } else {
                    setTimeout(() => {
                        el.style.height = 762 + 'px'
                        el.style.overflow = 'hidden'
                    }, 20)
                }
            },
            beforeLeave(el) {
                el.style.height = el.scrollHeight + 'px'
                el.style.overflow = 'hidden'
            },
            leave(el) {
                el.style.height = 0
                el.style.paddingTop = 0
                el.style.paddingBottom = 0
            },
        }
    }
</script>

<style scoped lang="scss" src="./serviceprogress.scss"></style>
